import React, { Component } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import LinearProgress from '@mui/material/LinearProgress';
import Formatter from '../../utils/Formatter';
import FormsApi from '../../api/forms';
import { connect } from 'react-redux';
import { showError, showMessage, confirmAction } from '../../actions/uiActions';
import {
  updateForm,
  updateServicer,
  addServicer
} from '../../actions/dataActions';
import Servicer from '../../forms/Servicer';
import { Checkbox, FormControl, FormControlLabel, ListItemText, ListSubheader, MenuItem, Select } from '@mui/material';
import { IDR_FORM_ID } from '../../constant/formIds';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

class AssignServicer extends Component {
  state = {
    faxWithTax: false,
    form: '',
    servicer: '',
    busy: false,
    customServicer: false,
    dynamicServicer: false,
    isFormExist: false,
    servicers: [],
    servicerNames: [],
    servicerList: [],
    multiple: false
  };

  componentDidMount() { 
    const msdServicers = Formatter.getServicersList(this.props.myStudentData);
    const customServicers = this.props.servicers
    const servicerList = [
      ...msdServicers.map(servicer => ({ value: servicer.id, label: servicer.servicer })),
      ...customServicers.map(servicer => ({ value: servicer.id, label: servicer.name }))
    ];
    const multiple = Number(this.props.form.form) === IDR_FORM_ID
    this.setState({ servicerList, multiple })
  }

  handleInputChange = e => {
    if (this.state.multiple) {
      const results = this.state.servicerList.filter(servicer => e.target.value.includes(servicer.value))
        .map(servicer => servicer.label);
        this.setState({
          servicerNames: results,
          [e.target.name]: e.target.value
        });
      return
    }
    const servicer = this.state.servicerList.find(servicer => servicer.value === e.target.value)
    this.setState({ servicer: e.target.value, servicerName: servicer.label });
  };
  addFormServicer = async (byPass = false) => {
    if (this.props.form.id === '') {
      this.props.showError(
        'Please select the form you want to assign to the user.'
      );
    } else if (this.state.servicer === '' && this.state.servicers.length === 0) {
      this.props.showError(
        'Please select the servicer to which the form should be sent.'
      );
    } else {
      this.setState({ busy: true });
      try {
        
        const payload = { 'servicer': this.state.servicer };
        if (this.state.servicers.length > 0) {
          payload.servicers = this.state.servicers;
          payload.shouldFaxWithTax = this.state.faxWithTax;
        }

        await FormsApi.updateForm(this.props.userId, this.props.form.id, payload)
        if (this.props.form.form !== IDR_FORM_ID) {
          this.props.onServicerAssigned(this.state.faxWithTax);
        } else {
          this.props.onFormSubmitted()
        }
        this.props.onCancel();
      } catch (error) {
        if (typeof error === "string") {
          return this.setState({ busy: false }, this.props.showError(error))
        }
        this.setState({ busy: false }, this.props.showError)
      }
    }
  };
  editServicer = () => {
    this.setState({
      editServicer: this.state.servicer
    });
  };

  render() {

    if (this.state.customServicer || this.state.editServicer) {
      return (
        <Servicer
          mode={this.state.customServicer ? 'add' : 'edit'}
          onCreated={servicer => {
            this.setState({
              servicer: servicer.id
            });
          }}
          onUpdated={servicer => {
            this.props.updateServicer(servicer);
            this.setState({
              servicer: servicer.id,
              customServicer: false,
              editServicer: null
            });
          }}
          onCancel={() =>
            this.setState({ customServicer: false, editServicer: null })
          }
          servicer={this.state.editServicer}
        />
      );
    }
    return (
      <Dialog
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        open={true}
      >
        <DialogTitle id="alert-dialog-title">Assign Service to Form</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            CAUTION: You are going to FAX the form to the servicer,
            before FAXing the form you must carefully review that all
            the information is correct and accurate, also you must double
            check to make sure the information in the form matches the one
            provided by the user and used in the analysis.
            Please confirm that you have reviewed the information and the form
            is correct and accurate. By confirming, the form will be sent to the
            servicer.
          </DialogContentText>
          <div className="form-group">
            <label>To which Servicer should the form be sent to:</label>
            <FormControl style={{ width: "100%" }}>
              <Select
                name="servicers"
                multiple={this.state.multiple}
                value={this.state.multiple ? this.state.servicers : this.state.servicer}
                onChange={this.handleInputChange}
                renderValue={(selected) => this.state.multiple ? this.state.servicerNames.join(', ') : this.state.servicerName}
                MenuProps={MenuProps}
              >
                {Formatter.getServicersList(this.props.myStudentData).map(
                  servicer => (
                    <MenuItem key={servicer.id} value={servicer.id}>
                      {this.state.multiple && <Checkbox checked={this.state.servicers.includes(servicer.id)} />}
                    <ListItemText primary={servicer.servicer} />
                  </MenuItem>
                  )
                )}
                <ListSubheader>Other Servicers</ListSubheader>
                {this.props.servicers.map(servicer => (
                  <MenuItem key={`${servicer.id}`} value={`${servicer.id}`}>
                    {this.state.multiple && <Checkbox checked={this.state.servicers.includes(`${servicer.id}`)} />}
                    <ListItemText primary={servicer.name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {this.state.servicer && this.state.dynamicServicer && (
              <button onClick={this.editServicer} className="link">
                Edit Servicer Settings
              </button>
            )}

            {Number(this.props.form.form) === 0 && <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.faxWithTax}
                  onChange={(e) => this.setState({ faxWithTax: !this.state.faxWithTax })}
                  value={this.state.faxWithTax}
                />
              }
              style={{
                display: "flex",
                alignItems: "center"
              }}
              label="Check this box to fax the tax return form with the user's IDR form"
            />}
          </div>
          {this.state.busy && <LinearProgress />}
        </DialogContent>
        {!this.state.busy && (
          <DialogActions>
            <Button
              variant="outlined"
              onClick={() => this.addFormServicer()}
              color="primary"
              autoFocus
            >
              Fax to Servicer
            </Button>
            <Button onClick={this.props.onCancel} color="primary">
              Cancel
            </Button>
          </DialogActions>
        )}
      </Dialog>
    );
  }
}
const mapStateToProps = state => {
  return {
    servicers: state.data.servicers,
    forms: state.data.forms
  };
};
export default connect(mapStateToProps, {
  showError,
  showMessage,
  confirmAction,
  updateForm,
  updateServicer,
  addServicer
})(AssignServicer);
